import { Component } from 'react';
import { connect } from "react-redux";
import { Modal, Button, Form, Row, Col, Container } from 'react-bootstrap'
import Loading from '../common/modal/Loading.js';

import { validateUser, trimUserFields } from "../common/function/userValidation.js";
import axios from "axios";
import configData from "../../config/config.json";

import { LOADING_STATUES, ALERT_TYPES } from "../constants/constants.js";
import Alert from '../common/modal/Alert.js';

const mapStateToProps = (state) => {
   return {
      currentUser: state.currentUserReducer
   };
}

class Translate extends Component {

   state = {
      userDefinedTranslations: this.props.userDefinedTranslations,
      translationFieldName: this.props.translationFieldName,
      loadingStatus: '',
      errors: {},
      alertType: ALERT_TYPES.OK
   }

   handleChange = (event) => {
      event.preventDefault();
      const targetId = event.target.id;
      if (targetId.includes("value")) {
         const index = targetId.replace("value", "");
         let userDefinedTranslations = [...this.state.userDefinedTranslations];
         let translation = { ...userDefinedTranslations[index] };
         translation.text = event.target.value;
         userDefinedTranslations[index] = translation;
         this.setState({
            userDefinedTranslations
         });
      }
   }

   showLoading = () => {
      if (this.state.loadingStatus === "") {
         this.setState({
            loadingStatus: LOADING_STATUES.LOADING
         })
         return true;
      }
      return false;
   }

   validateAndSubmit = () => {
      let errors = validateUser(this.state, false);
      if (errors && Object.keys(errors).length > 0) {
         this.setState({ errors });
         return;
      }

      if (this.showLoading() === true) {

         const { loadingStatus, alertType, errors,
            ...request } = this.state; // remove UI only fields before submitting

         axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/userDefinedTranslation", request, { withCredentials: true })
            .then((response) => {
               this.setState({ loadingStatus: "" })
               this.props.closeTranslate();
            }, (error) => {
               var response = error.response;
               if (response.status === 403) {
                  this.props.history.push('/login');
               } else {
                  this.setState({ loadingStatus: "", redirectToLogin: false }, this.showWarning(error.response.data.message));
               }
            });
      }
   }

   handleSubmit = (event) => {
      event.preventDefault();

      const trimmedUserFields = trimUserFields(this.state);
      this.setState({ ...trimmedUserFields }, function () {
         this.validateAndSubmit();
      });
   }

   handleCloseClick = (event) => {
      if (event) {
         event.preventDefault();
      }
      this.setState({ errors: {} })
      this.props.closeTranslate();
   }

   showAlert = (alertMessage) => {
      this.setState({
         showAlert: true,
         alertMessage
      })
   }

   showWarning = (alertMessage) => {
      this.setState({
         alertType: ALERT_TYPES.WARNING,
         showAlert: true,
         alertMessage
      })
   }

   hideAlert = () => {
      this.setState({
         showAlert: false,
         alertMessage: ""
      })
      if (this.state.redirectToLogin) {
         this.props.history.push('/login');
      }
   }

   render() {
      let paragraphTable =
         <>
            {
               this.state.userDefinedTranslations.map((translation, index) => (
                  <Row>
                     <Col xs={3} sm={3} md={3} xl={3} >
                        <Form.Control type='text' id={'language' + index} disabled='true' value={this.state.userDefinedTranslations[index].language} style={{ maxWidth: 400 }} />
                     </Col>
                     <Col xs={6} sm={6} md={7} xl={8} style={{ paddingLeft: 0 }}>
                        <Form.Control type='text' id={'value' + index} disabled={this.state.status === 'LOADING'} onChange={this.handleChange} value={this.state.userDefinedTranslations[index].text} />
                     </Col>
                  </Row>
               ))
            }
         </>

      return (
         <>
            <Modal show={this.props.show} onHide={this.handleCloseClick} size="lg" centered>
               <Form onSubmit={this.handleSubmit}>
                  <Modal.Header closeButton>
                     <Modal.Title style={{ color: '#145A7B' }}> Translate </Modal.Title>
                  </Modal.Header>
                  <Modal.Body style={{ borderTop: '2px solid black', borderBottom: '2px solid black', background: '#145A7B', color: 'white' }}>
                     <Container fluid="true" style={{ paddingLeft: 50, paddingBottom: 50, marginTop: 10, background: 'white', color: 'black', border: '2px solid black', borderRadius: '5px' }}>
                        <div>{this.props.translationCode}</div>
                        <div><strong>Original Text:</strong></div>
                        <div>{this.props.originalText}</div>
                        <br />

                        {paragraphTable}
                     </Container>
                  </Modal.Body>
                  <Modal.Footer>
                     <Button variant="primary" type="submit" >Update</Button>
                     <Button variant="secondary" onClick={this.handleCloseClick}>Close</Button>
                  </Modal.Footer>
               </Form>
            </Modal>
            <Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
            <Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={this.state.alertType} />
         </>
      )
   }
}

export default connect(mapStateToProps, null)(Translate);